import { Box } from "theme-ui";
import { AnimatedScrollPrompt } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  Box,
  AnimatedScrollPrompt,
  React
};